// src/store/teamSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Adjust this to your API base
const API_URL = "http://localhost:5000/api/team";

// ================== Thunks ==================
export const getTeam = createAsyncThunk("team/getTeam", async (_, thunkAPI) => {
  try {
    const res = await axios.get(API_URL);
    return res.data; // should be an array of members
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});

export const addMember = createAsyncThunk("team/addMember", async (data, thunkAPI) => {
  try {
    const res = await axios.post(API_URL, data);
    return res.data; // newly created member
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});

export const updateMember = createAsyncThunk(
  "team/updateMember",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await axios.put(`${API_URL}/${id}`, data);
      return res.data; // updated member
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteMember = createAsyncThunk("team/deleteMember", async (id, thunkAPI) => {
  try {
    await axios.delete(`${API_URL}/${id}`);
    return id; // return id for reducer
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});

// ================== Slice ==================
const teamSlice = createSlice({
  name: "team",
  initialState: {
    members: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // getTeam
    builder
      .addCase(getTeam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTeam.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload || [];
      })
      .addCase(getTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch team";
      });

    // addMember
    builder
      .addCase(addMember.fulfilled, (state, action) => {
        state.members.push(action.payload);
      })
      .addCase(addMember.rejected, (state, action) => {
        state.error = action.payload || "Failed to add member";
      });

    // updateMember
    builder
      .addCase(updateMember.fulfilled, (state, action) => {
        const idx = state.members.findIndex((m) => m._id === action.payload._id);
        if (idx !== -1) state.members[idx] = action.payload;
      })
      .addCase(updateMember.rejected, (state, action) => {
        state.error = action.payload || "Failed to update member";
      });

    // deleteMember
    builder
      .addCase(deleteMember.fulfilled, (state, action) => {
        state.members = state.members.filter((m) => m._id !== action.payload);
      })
      .addCase(deleteMember.rejected, (state, action) => {
        state.error = action.payload || "Failed to delete member";
      });
  },
});

export default teamSlice.reducer;
